import Vue from 'vue'
import ElementUI from 'element-ui'
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/panke-theme.css'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false

/**
 * 登录态过期预警（规划 §8 未做 refresh token 的轻量兜底）：
 * 每 60s 检查一次 JWT exp，过期前 5 分钟提示用户保存工作，
 * 避免在填表中途被 401 踢回登录页造成数据丢失。
 */
function decodeJwtExp(token) {
  try {
    const payload = token.split('.')[1]
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
    return decoded && decoded.exp ? decoded.exp * 1000 : null
  } catch (e) {
    return null
  }
}

let warned = false
setInterval(() => {
  const token = store.state.token
  if (!token) { warned = false; return }
  const exp = decodeJwtExp(token)
  if (!exp) return
  const remainMs = exp - Date.now()
  if (remainMs <= 0) {
    warned = false
  } else if (remainMs <= 5 * 60 * 1000 && !warned) {
    warned = true
    Message.warning('登录即将过期，请尽快保存当前内容，避免丢失')
  }
}, 60000)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
